module.exports = __webpack_public_path__ + "static/media/seat1.6d1dddee.svg";